<!--车速分析图表-->
<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">{{ $t('车速分析.page_title') }}</span>
      <div style="flex:1;text-align: right;">
        <quickQuery :isDownload="false" @handleQuery="onQuery" @quickQuery="onQuery" style="text-align: right" />
      </div>
    </div>
    <el-divider></el-divider>
    <div class="page_container">
      <div id="speed-chart" style="width: 100%; height: 400px"></div>
    </div>
  </div>
</template>

<script>
// import * as echarts from "echarts";
import { mapState } from 'vuex'
import settings from "@/settings";
import quickQuery from '../components/generalOrQuickQuery.vue'
import { queryVehicleSpeedMileageAnalysisCurve } from "@/http/vehicle";
export default {
  name: "speedCharts",
  components: {
    quickQuery,
  },
  data() {
    return {
      loading: false,
      form: {
        queryDate: this.getTodayDate(),
      },
      speedChart: undefined,
        beginDate: "",
            endDate: "",

    }
  },
  activated() {
    // 组件激活时重新初始化图表
    this.resizeChart();
  },
  mounted() {
     const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.initChart();
 
  },
  computed: {
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  methods: {
    resizeChart() {
      // 图表自适应大小
      this.speedChart.resize();
    },
    getSelectedVehicles() {
      var vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    queryChartData() {
      if (!this.beginDate.length || !this.endDate.length) {
        this.$message.error(this.$t('time.selectQueryTime'));
        return;
      }
      var vehicles = this.getSelectedVehicles();


      this.loading = true;


      queryVehicleSpeedMileageAnalysisCurve({
        vids: vehicles,
        startDate: this.beginDate,
        endDate: this.endDate,
      }).then(res => {
        this.loading = false;
        // console.log(res);
        var speedRanges = [];
        var RunTime = [];//累计运行时长      
        var RunMileage = [];//累计里程      
        var ARunTime = [];//时长占比      
        var ARunMileage = [];//里程占比  


        res.data.forEach(element => {
          speedRanges.push(element.SpeedRange);
          RunTime.push(element.RunTime);
          RunMileage.push(element.RunMileage);
          ARunTime.push(element.ARunTime);
          ARunMileage.push(element.ARunMileage);

        });

        const option = {

          xAxis: {
            type: "category",
            data: speedRanges,
          },

          series: [
            {

              name: this.$t('statistics.accumulatedMileage'),
              type: "line",
              smooth: true,
              data: RunMileage,

            },
            {
              name: this.$t('statistics.mileageRatio'),
              type: "line",
              smooth: true,
              data: ARunMileage,

            },
            {
              name: this.$t('statistics.accumulatedDuration'),
              type: "line",
              smooth: true,
              data: RunTime,

            },
            {
              name: this.$t('statistics.durationRatio'),
              type: "line",
              smooth: true,
              data: ARunTime,

            },
          ],
        };

        this.speedChart.setOption(option);
      })
    },
    onQuery(val) {
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      this.queryChartData();
    },

    getTodayDate() {
      //格式化为yyyy-MM-dd

      return [this.moment(new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'), this.moment(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD')]

    },
    initChart() {
      // 初始化图表
      const chartDom = document.getElementById("speed-chart");
      this.speedChart = echarts.init(chartDom);

      // 配置项
      const option = {
        tooltip: {
          trigger: "axis",
          formatter: params => {
            const param_mileage = params[0];
            const param_mileage_a = params[1];
            const param_hour = params[2];
            const param_hour_a = params[3];
            const accumulatedMileage = this.$t('statistics.accumulatedMileage');
            const accumulatedDuration = this.$t('statistics.accumulatedDuration');
            const mileageRatio = this.$t('statistics.mileageRatio');
            const durationRatio = this.$t('statistics.durationRatio');

            return `
              <div style="font-weight: bold;">${param_mileage.name}(km/h)</div>
              <div>${accumulatedMileage}: ${param_mileage.value} </div>
              <div>${mileageRatio}: ${(param_mileage_a.value * 100).toFixed(2)}% </div>
              <div>${accumulatedDuration}: ${param_hour.value} </div>
                 <div>${durationRatio}: ${(param_hour_a.value * 100).toFixed(2)}% </div>           
            `;

          }
        },
        legend: {
          data: [this.$t('statistics.accumulatedMileage'), this.$t('statistics.accumulatedDuration')],
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: [
          {
            type: "value",
            name: this.$t('statistics.accumulatedMileage'),
            min: 0, max: function (value) {
              return Math.ceil(value.max * 1.1);
            },
          },
          {
            type: "value",
            name: this.$t('statistics.accumulatedDuration'),
            // 让第二个 y 轴显示在右侧
            position: "right",
            min: 0, max: function (value) {

              return Math.ceil(value.max * 1.1);
            },
          },
        ],
        series: [
          {
            name: this.$t('statistics.accumulatedMileage'),
            type: "line",
            smooth: true,
            data: [],
            yAxisIndex: 0,
            itemStyle: {
              color: "#FF8C00", // 亮蓝色
            },
          },
          {
            show: false,
            name: this.$t('statistics.mileageRatio'),
            symbol: "none",
            type: "line",
            data: [],
            color: 'transparent',    // 透明色

          },

          {
            name: this.$t('statistics.accumulatedDuration'),
            type: "line",
            smooth: true,
            data: [],
            yAxisIndex: 1,
            itemStyle: {
              color: "#2A7AFF", // 草绿色
            },
          },
          {
            show: false,
            name: this.$t('statistics.durationRatio'),
            symbol: "none",
            type: "line",
            data: [],
            color: 'transparent',    // 透明色
            // 隐藏该系列
          },
        ],
      };

      // 使用配置项显示图表
      this.speedChart.setOption(option);
      //页面resize
      window.addEventListener("resize", () => {
        this.speedChart.resize();
      });
    },
  },
};
</script>

<style scoped>
/* 可以在这里添加样式 */
</style>
